import { useEffect, useState } from "react";
import carousel1 from "../../../assets/images/login-carousel-01.svg";
import carousel2 from "../../../assets/images/login-carousel-02.svg";
import carousel3 from "../../../assets/images/login-carousel-03.svg";
import styles from "./login-carousel.module.scss";

const slides = [
  {
    image: carousel1,
    title: "Monitor and Control",
    description:
      " Turn devices on or off remotely and View real-time and historical energy consumption data",
  },
  {
    image: carousel2,
    title: "Schedule Usage",
    description:
      "Set schedules for your appliances to optimize energy consumption",
  },
  {
    image: carousel3,
    title: "Optimize Consumption",
    description:
      "Receive personalized recommendations to reduce your energy bills based on future usage prediction.",
  },
];

const LoginCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  const currentSlide = slides[currentIndex];

  return (
    <div className={styles.carouselContainer} id="login-carousel">
      <div key={currentIndex} className={styles.slideContent}>
        <div className={styles.imageWrapper}>
          <img
            src={currentSlide.image}
            alt={currentSlide.title}
            className={styles.slideImage}
          />
        </div>
        <h3 className={styles.slideTitle}>{currentSlide.title}</h3>
        <p className={styles.slideDescription}>{currentSlide.description}</p>
      </div>
      <div className={styles.carouselDots}>
        {slides.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${currentIndex === index ? styles.activeDot : ""}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
            id={`carousel-dot-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LoginCarousel;
